import React, { useState, useMemo } from 'react';
import styled from 'styled-components';
import { Input, Table, TableProps, Text, theme } from 'components';
import { Icon, EmptyStreet } from '@brokerbay/elements-web';
import { CoopRelationshipDTO } from '@bb/domain/dist/types';

type CoopListTableProps = {
  coops: CoopRelationshipDTO[];
  columns: TableProps['columns'];
  loading: boolean;
};

const CoopListTable: React.FC<CoopListTableProps> = ({
  coops,
  columns,
  loading,
}) => {
  const [searchText, setSearchText] = useState('');

  const coopDatas = useMemo(
    () =>
      coops.filter(
        ({ name, label }) =>
          `${name} (${label})`
            .toLowerCase()
            .includes(searchText.toLowerCase()) ||
          label.toLowerCase().includes(searchText.toLowerCase()),
      ),
    [coops, searchText],
  );

  return coops.length || loading ? (
    <StyledContainer>
      <StyledInput
        prefix={<Icon icon="searchOutlined" color={'primary'} size={15} />}
        onChange={e => setSearchText(e.target.value)}
        size="large"
        placeholder="Search cooperating organization"
        style={{ width: '100%' }}
      />
      <StyledTable
        columns={columns}
        dataSource={coopDatas}
        pagination={{ pageSize: 5, position: ['bottomCenter'] }}
        loading={loading}
      />
    </StyledContainer>
  ) : (
    <StyledContainer>
      <EmptyStreet width={'400px'} height={'200px'} />
      <Text fontSize={20}>
        There are currently no auto-cooperations configured for this user.
      </Text>
    </StyledContainer>
  );
};

export default CoopListTable;

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`;

const StyledInput = styled(Input)`
  width: 100%;
`;

const StyledTable = styled(Table)`
  width: 100%;
  .ant-table-filter-trigger.active .anticon-filter {
    color: ${theme.blueBase};
  }
`;
